export const pluginsSkipChoosePathway = [
  '291c4490-4981-11ec-8f92-0b8eda21ab42',
  '1dac9300-416a-11eb-ba59-155b4a827473',
];
